
























import {Component, Prop, Mixins} from 'vue-property-decorator';
import DialogMixin from '@/mixins/dialog/DialogMixin';

@Component({
    inheritAttrs: false,
})
export default class CDeleteDialog extends Mixins(DialogMixin) {
    private deleting: boolean = false;
    private errorMsg: string | null = null;

    get title() {
        if (this.data) return 'Удалить?';
        return 'Удалить все?';
    }

    get msg() {
        if (this.data) return 'Вы уверены, что хотите удалить запись?';
        return 'Вы уверены, что хотите удалить все записи?';
    }

    onOk() {
        if (this.errorMsg) return this.close();

        if (this.options.deleteCallback && typeof this.options.deleteCallback === 'function') {
            this.deleting = true;
            this.options.deleteCallback(this.data);
        }
    }

    error(msg: string) {
        this.errorMsg = msg;
        this.deleting = false;
    }

    clear() {
        this.deleting = false;
        this.data = null;
        this.errorMsg = null;
    }
}
